import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_toast = _resolveComponent("ion-toast")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_router_outlet, { key: _ctx.key }),
      _createVNode(_component_ion_toast, {
        "is-open": _ctx.toastVisible,
        color: _ctx.toastColor,
        message: _ctx.toastMessage,
        duration: 3000,
        onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setToastVisibility(false)))
      }, null, 8, ["is-open", "color", "message"])
    ]),
    _: 1
  }))
}